import React, { memo } from 'react';

import { Box } from '@mui/material';
import TooltipWrapper from 'app/shared/components/common/TooltipWrapper';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { getModifiedFieldChangeKind } from 'utils/pendingChangeKind';

import DataDisplay, { useResponsiveDataDisplayVariant } from '../../coreDesignSystem/DataDisplay';

import { getLoanInfoCardsConfig } from './LoanInfoCards.config';
import { loanInfoCardsWrapperStyles } from './LoanInfoCards.styles';

const LoanInfoCards = ({
  summary,
  isLoading,
  customInfoCardStyles,
  getPendingChangeAuthors = null,
}) => {
  const { modifiedFields, modifiedFieldDetails, ...restSummaryFields } = summary ?? {};

  const loanInfoCardsConfig = getLoanInfoCardsConfig(restSummaryFields);
  const dataDisplayVariant = useResponsiveDataDisplayVariant();

  return (
    <Box sx={loanInfoCardsWrapperStyles}>
      {loanInfoCardsConfig.map(({ name, value, icon, hoverContent, iconColor, fieldName }) => {
        const card = (
          <Box sx={customInfoCardStyles}>
            <DataDisplay
              changeKind={getModifiedFieldChangeKind(summary, fieldName)}
              icon={icon}
              iconColor={iconColor}
              isLoading={isLoading}
              pendingChangeAuthors={
                getPendingChangeAuthors?.(modifiedFieldDetails, fieldName) ?? null
              }
              title={name}
              value={value}
              variant={dataDisplayVariant}
            />
          </Box>
        );

        if (!hoverContent || isLoading) {
          return <React.Fragment key={name + value}>{card}</React.Fragment>;
        }

        return (
          <TooltipWrapper key={name + value} title={hoverContent}>
            {card}
          </TooltipWrapper>
        );
      })}
    </Box>
  );
};

LoanInfoCards.propTypes = {
  summary: PropTypes.shape({
    loanPurpose: PropTypes.string,
    loanAmount: PropTypes.number,
    interestRate: PropTypes.number,
    lockExpirationDate: PropTypes.string,
    programName: PropTypes.string,
    modifiedFields: PropTypes.array,
    modifiedFieldDetails: PropTypes.array,
  }),
  customInfoCardStyles: PropTypes.object,
  // (modifiedFieldDetails, fieldName) => author rows (useModifiedFieldPendingChangeAuthors) for the modified cards'
  // author dots; without it the cards show no dots.
  getPendingChangeAuthors: PropTypes.func,
  ...WithLoadingPropTypes,
};

export default memo(LoanInfoCards);
